import Phaser from 'phaser'
import { Panel } from '../controls/Panel'
import { Button } from '../controls/buttons/Button'
import { GameConfig } from '../GameConfig'
import { LevelManager } from './LevelManager'
import { SceneHelper } from '../utils/SceneHelper'

/**
 * @description: 游戏欢迎场景
 */
export class WelcomeScene extends Phaser.Scene {
    private levelManager!: LevelManager;
    constructor() {
        super('WelcomeScene')
    }

    /**预加载资源 */
    preload() {
        SceneHelper.showLoading(this);
        this.load.image('bg', 'assets/images/bg.png')
        this.load.svg('lock', 'assets/icons/lock.svg')
        this.load.image('play', 'assets/icons/play.svg')
        this.load.video('story', 'assets/video/story.mp4')
    }

    //------------------------------------------------------------
    // UI
    //------------------------------------------------------------
    /**创建场景 */
    async create() {
        // 加载关卡数据
        this.levelManager = await LevelManager.getIntance();

        // 背景
        this.add.image(0, 0, 'bg')
            .setOrigin(0, 0)
            .setDisplaySize(this.cameras.main.width, this.cameras.main.height)

        // 首次游戏时播放视频
        if(!localStorage.getItem('firstVisit')) {
            this.playVidio()
            localStorage.setItem('firstVisit', 'true');
        }

        // 创建播放按钮
        new Button(this, this.cameras.main.width - 50, 40, '', { width: 38, height: 38, iconWidth: 24, iconHeight: 24, icon: 'play'})
           .onClick(() => this.playVidio());

        // UI
        this.createTitle();
        this.createLevelPanel();
        this.createCopyright();
    }

    /**播放视频 */
    private playVidio() {
        // 局中放置视频
        //this.add.video(400, 300).loadURL('assets/video/story.mp4');
        var centerX = this.cameras.main.centerX;
        var centerY = this.cameras.main.centerY;
        const video = this.add.video(centerX, centerY, 'story')
            .setOrigin(0.5)
            .setInteractive()
            .on('pointerdown', () => {
                video.stop();
                video.setVisible(false);
            })
            .on('complete', () => {
                video.setVisible(false);
            });
        video.height = this.cameras.main.height;
        video.width = this.cameras.main.width;
        //video.setScale(0.45);

        // 等待视频加载完成后设置尺寸
        //video.once('loadeddata', () => {
        //    // 计算视频与屏幕的宽高比
        //    const screenWidth = this.cameras.main.width;
        //    const screenHeight = this.cameras.main.height;
        //    const videoWidth = video.width;
        //    const videoHeight = video.height;
        //    
        //    // 计算合适的缩放比例，确保视频完全覆盖屏幕
        //    const scaleX = screenWidth / videoWidth;
        //    const scaleY = screenHeight / videoHeight;
        //    const scale = Math.max(scaleX, scaleY); // 取较大值确保覆盖
        //    video.setScale(scale);
        //    
        //    // 居中显示
        //    const newWidth = videoWidth * scale;
        //    const newHeight = videoHeight * scale;
        //    video.setPosition((screenWidth - newWidth) / 2, (screenHeight - newHeight) / 2);
        //});
        
        video.setDepth(1000);
        video.play();
    }

    /**创建标题 */
    private createTitle() {
        var title = GameConfig.text.title;
        this.add.text(this.cameras.main.centerX, 60, title, {
            fontSize: '36px',
            color: '#000000',
            stroke: '#ffffff',
            strokeThickness: 6,
            fontFamily: GameConfig.fonts.title
        }).setOrigin(0.5)
    }

  /**创建版权信息 */
  createCopyright() {
      const lblCopyright = this.add.text(
        this.cameras.main.centerX,
        this.cameras.main.height - 30,
        'CopyRight ©2025 ',
        {
            fontSize: '14px',
            color: '#000000',
            stroke: '#ffffff',
            strokeThickness: 4,
            fontFamily: GameConfig.fonts.title
        }
      ).setOrigin(0.5).setInteractive().on('pointerdown', () => {
          this.scene.start('AboutScene');
      });
  }

  /**创建关卡选择面板 */
  private createLevelPanel() {
      const panelWidth = this.game.canvas.width - 40;// 600
      const panelHeight = this.game.canvas.height - 280; //400
      const panel = new Panel(this, 20, 200, panelWidth, panelHeight, panelHeight * 2, 10);

      // TODO：考虑直接用 GridLayout 代替
      // 计算起始位置
      const buttonSize = 40;
      const spacing = 10;
      const columns = panelWidth / (buttonSize + spacing*2) | 0;
      const startX = spacing;
      const startY = spacing * 1.5;

      // 创建关卡按钮
      const levels = this.levelManager.getLevels();
      levels.forEach((level, index) => {
          const col = index % columns;
          const row = Math.floor(index / columns);
          const x = startX + col * (buttonSize + spacing) + buttonSize/2;
          const y = startY + row * (buttonSize + spacing) + buttonSize/2;

          // 创建按钮
          const button = new Button(this, x, y, (index + 1).toString(), {
            width: buttonSize,
            height: buttonSize,
            bgColor: level.unlocked ? 0x4a90e2 : 0x95a5a6,
            radius: 10
          }).setOrigin(0, 0);  // todo

          // 如果关卡未解锁，添加锁定图标
          if (!level.unlocked) {
              const lock = this.add.image(x, y, 'lock').setDisplaySize(24, 24).setOrigin(0);
              panel.add(lock);
          }

          // 添加点击事件
          if (level.unlocked) {
            button.onClick(() => {
                this.levelManager.setCurrentLevel(index);
                SceneHelper.goScene(this, 'BoxGameScene');
            })
          }

          panel.add(button);
      });
  }
}